module.exports = __webpack_public_path__ + "static/self-portrait-ae25e171371b4391cc0d0dbbd1e25cc0.jpg";